import { getResponseHeader } from '~/lib/utils/fetch';

export const useGamingXPHeader = (response) => {
  const gaming = useGamingStore();
  const xpHeader = getResponseHeader(response, AdamHeader.NomadGamingXp);
  if (xpHeader) {
    gaming.setXP(parseInt(xpHeader, 0));
  }
};
